import { Box } from '@chakra-ui/react';

export const NavCalendarSVG = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <Box>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        {...props}
      >
        <path
          d="M22.8889 10.5H24C24.5304 10.5 25.0391 10.7049 25.4142 11.0695C25.7893 11.4342 26 11.9287 26 12.4444V26.0556C26 26.5713 25.7893 27.0658 25.4142 27.4305C25.0391 27.7951 24.5304 28 24 28H12C11.4696 28 10.9609 27.7951 10.5858 27.4305C10.2107 27.0658 10 26.5713 10 26.0556V12.4444C10 11.9287 10.2107 11.4342 10.5858 11.0695C10.9609 10.7049 11.4696 10.5 12 10.5H13.1111"
          stroke={props.stroke || 'white'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.2307 8H14.7692C14.1744 8 13.6923 8.41973 13.6923 8.9375V10.8125C13.6923 11.3303 14.1744 11.75 14.7692 11.75H21.2307C21.8255 11.75 22.3076 11.3303 22.3076 10.8125V8.9375C22.3076 8.41973 21.8255 8 21.2307 8Z"
          stroke={props.stroke || 'white'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.6924 16.8887H22.3078"
          stroke={props.stroke || 'white'}
          strokeWidth="1.25"
          strokeLinecap="round"
        />
      </svg>
    </Box>
  );
};
export default NavCalendarSVG;
